// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3th78","right":"styles_right__2-dGx"};